import { Component, Input } from '@angular/core';
import { Current } from '../../models/menu.interfaces';

@Component({
  selector: 'idp-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  @Input() current!: Current;
}
